export const rootPaths = {
  root: '/',
  dashboardRoot: 'dashboard',
  pagesRoot: 'pages',
  miscRoot: 'misc',
  authRoot: 'authentication',
  pricingRoot: 'pricing',
  authDefaultJwtRoot: 'default/jwt',
  errorRoot: 'error',
  ecommerceRoot: 'ecommerce',
  ecommerceAdminRoot: 'admin',
  ecommerceCustomerRoot: 'customer',
  eventsRoot: 'events',
  emailRoot: 'email',
  kanbanRoot: 'kanban',
  appsRoot: 'apps',
};

const paths = {
  starter: `/${rootPaths.pagesRoot}/starter`,

  defaultJwtLogin: `/${rootPaths.authRoot}/${rootPaths.authDefaultJwtRoot}/login`,
  defaultJwtSignup: `/${rootPaths.authRoot}/${rootPaths.authDefaultJwtRoot}/sign-up`,
  defaultJwtForgotPassword: `/${rootPaths.authRoot}/${rootPaths.authDefaultJwtRoot}/forgot-password`,
  defaultJwt2FA: `/${rootPaths.authRoot}/${rootPaths.authDefaultJwtRoot}/2FA`,
  defaultJwtSetPassword: `/${rootPaths.authRoot}/${rootPaths.authDefaultJwtRoot}/set-password`,

  defaultLoggedOut: `/${rootPaths.authRoot}/default/logged-out`,
  pricingColumn: `/${rootPaths.pricingRoot}/column`,
  notifications: `/${rootPaths.pagesRoot}/notifications`, //? update path

  404: `/${rootPaths.errorRoot}/404`,
};

export const authPaths = {
  /* ---------------------------------JWT----------------------------------------- */
  login: paths.defaultJwtLogin,
  signup: paths.defaultJwtSignup,
  forgotPassword: paths.defaultJwtForgotPassword,
  setNewPassword: paths.defaultJwtSetPassword,
  twoFactorAuth: paths.defaultJwt2FA,
};

export const apiEndpoints = {
  register: '/auth/register',
  login: '/auth/login',
  logout: '/auth/logout',
  profile: '/auth/profile',
  getUsers: '/users',
  forgotPassword: '/api/couple/forgot-password',
  setPassword: '/api/couple/reset-password',
  getProduct: (id: string) => `e-commerce/products/${id}`,
};

// Wedding App Specific Paths
export const weddingPaths = {
  // Base paths for guards
  coupleBase: '/couple',
  guestBase: '/wedding',

  // Public interactive demo entry (no guard). Mints a disposable Heirloom
  // sandbox and drops the visitor into the dashboard. Linked from the landing
  // page ("Try the full plan") and reused by any in-app "Try" button.
  tryDemo: '/try',

  // Couple (Organizer) Paths
  coupleLogin: '/couple/login',
  // Event-type chooser — the entry point for new organizers. Each choice routes
  // to one of the dedicated create-* flows below (which fix `eventType`).
  coupleStart: '/couple/start',
  coupleCreateEvent: '/couple/create-event',
  coupleCreateBaptism: '/couple/create-baptism',
  coupleCreateWeddingBaptism: '/couple/create-wedding-baptism',
  coupleDashboard: '/couple/dashboard',
  // Full-screen AI planner (focus page). Full-bleed, desktop-only for now —
  // reached from the expand control in the assistant drawer.
  couplePlanner: '/couple/planner',
  coupleOrganizer: '/couple/organizer',
  coupleOrganizerTasks: '/couple/organizer/tasks',
  coupleOrganizerBudget: '/couple/organizer/budget',
  coupleOrganizerTimeline: '/couple/organizer/timeline',
  coupleOrganizerCategory: (slug: string) => `/couple/organizer/categories/${slug}`,
  coupleOrganizerVendor: (id: string) => `/couple/organizer/vendors/${id}`,
  coupleInsights: '/couple/insights',
  // The digital invitation editor (Heirloom; a teaser on other plans). `?section=`
  // opens one of its sections.
  coupleInvitation: '/couple/invitation',
  coupleQrCode: '/couple/qr-code',
  // The table-card designer, a page of its own: `?preset=` / `?template=` picks the template.
  coupleQrCodeDesign: '/couple/qr-code/design',
  coupleUpload: '/couple/upload',
  coupleEventsList: '/couple/events',
  coupleBilling: '/couple/billing',
  coupleProfile: '/couple/profile',
  coupleSettings: '/couple/settings',
  coupleGuests: '/couple/guests',
  coupleSeating: '/couple/seating',
  coupleWishes: '/couple/wishes',
  coupleQuiz: '/couple/quiz',
  coupleQuizResults: '/couple/quiz/results',
  coupleForgotPassword: '/couple/forgot-password',
  coupleSetPassword: '/couple/set-password',
  coupleVerifyEmail: '/couple/verify-email',

  // Guest (Uploader) Paths
  guestJoin: (eventId: string) => `/wedding/${eventId}/join`,
  guestDashboard: (eventId: string) => `/wedding/${eventId}/dashboard`,
  guestUpload: (eventId: string) => `/wedding/${eventId}/upload`,
  guestGallery: (eventId: string) => `/wedding/${eventId}/gallery`,
  guestAlbum: (eventId: string, albumId: string) => `/wedding/${eventId}/album/${albumId}`,
  guestWishes: (eventId: string) => `/wedding/${eventId}/wishes`,
  guestQuiz: (eventId: string) => `/wedding/${eventId}/quiz`,
  guestQuizResults: (eventId: string) => `/wedding/${eventId}/quiz/results`,
  guestSeat: (eventId: string) => `/wedding/${eventId}/seat`,

  // Fallback paths for guards when eventId is missing
  guestJoinGeneral: '/wedding/join',
  guestGalleryGeneral: '/wedding/gallery',
};

export default paths;
